<template>
  <div class="setmain">
    <div class="set_contain">
      <div class="container_left">
        <div class="toolsBar">
          <el-button
            style="margin-left:10px"
            type="text"
            size="mini"
            @click="dialogTokenFormVisible = true"
          >
            添加token
          </el-button>
        </div>
        <el-tree
          accordion
          :data="treeData"
          :props="defaultProps"
          node-key="id"
          :expand-on-click-node="true"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="treeNodeClick"
          ref="menutree"
          highlight-current
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span
              v-if="data.type == 'token'"
              style="text-align:right;display:inline-block;width:100px"
            >
              <el-button
                type="text"
                size="mini"
                @click="() => append(node, data)"
              >
                添加
              </el-button>
            </span>
            <span v-if="data.type == 'api'">
              <el-button
                type="text"
                size="mini"
                @click="() => edit(node, data)"
              >
                修改
              </el-button>
              <span v-if="data.ban == false">
                <el-button
                  type="text"
                  size="mini"
                  @click="() => ban(node, data)"
                >
                  禁用
                </el-button>
              </span>
              <span v-if="data.ban == true">
                <el-button
                  type="text"
                  size="mini"
                  @click="() => resume(node, data)"
                >
                  恢复
                </el-button>
              </span>
              <el-button
                type="text"
                size="mini"
                @click="() => remove(node, data)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
        <el-dialog
          title="token添加"
          :visible.sync="dialogTokenFormVisible"
          width="30%"
          @close="closeTokenDialog"
          :close-on-click-modal="false"
        >
          <el-form
            size="medium"
            :model="tokenform"
            ref="tokenform"
            :rules="rules"
            label-width="20%"
            label-position="right"
            @submit.native.prevent
          >
            <el-form-item label="token名称" prop="token">
              <el-input
                size="medium"
                v-model="tokenform.token"
                autocomplete="off"
                @keyup.enter.native="submitTokenForm(tokenform)"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTokenFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitTokenForm(tokenform)"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          title="修改别名"
          :visible.sync="dialogEditAliasVisible"
          width="30%"
          @close="closeEditDialog"
          :close-on-click-modal="false"
        >
          <el-form
            size="medium"
            :model="editform"
            ref="editform"
            :rules="rules"
            label-width="20%"
            label-position="right"
            @submit.native.prevent
          >
            <el-form-item label="api别名" prop="alias">
              <el-input
                size="medium"
                v-model="editform.alias"
                autocomplete="off"
                @keyup.enter.native="submitAliasForm(editform)"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogEditAliasVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitAliasForm(editform)"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          title="api添加"
          :visible.sync="dialogApiFormVisible"
          width="30%"
          @close="closeApiDialog"
          :close-on-click-modal="false"
        >
          <el-form
            size="medium"
            :model="apiform"
            ref="apiform"
            :rules="rules"
            label-width="20%"
            label-position="right"
          >
            <el-form-item label="apiId" prop="apiId">
              <el-select
                v-model="apiform.apiId"
                placeholder="请选择apiId"
                style="width:100%"
                value-key="apiId"
                @change="ApiSelect"
                filterable
              >
                <el-option
                  v-for="item in apiList"
                  :key="item.apiId"
                  :label="item.apiId"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!-- <el-input size="medium" v-model="form.alias" autocomplete="off"></el-input> -->
            </el-form-item>
            <el-form-item label="交易所" prop="exchange">
              <!-- <el-select v-model="apiform.exchange" placeholder="请选择交易所" style="width:100%">
              <el-option v-for="item in exchangeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> -->
              <el-input
                size="medium"
                v-model="apiform.exchange"
                :readonly="true"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="api别名" prop="alias">
              <el-input
                size="medium"
                v-model="apiform.alias"
                autocomplete="off"
                @keyup.enter.native="submitApiForm(apiform)"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="apiType">
              <el-radio v-model="apiform.apiType" label="1">现货</el-radio>
              <el-radio v-model="apiform.apiType" label="2">合约</el-radio>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogApiFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitApiForm(apiform)"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          title="用户添加"
          :visible.sync="dialogUserFormVisible"
          width="30%"
          @close="closeUidDialog"
          :close-on-click-modal="false"
        >
          <el-form
            size="medium"
            :model="uidform"
            ref="uidform"
            :rules="rules"
            label-width="20%"
            label-position="right"
          >
            <el-form-item label="用户名称" prop="uid">
              <el-select
                v-model="uidform.uid"
                placeholder="请选择用户"
                style="width:100%"
                multiple
                filterable
              >
                <el-option
                  v-for="item in userList"
                  :key="item.uid"
                  :label="item.label"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
              <!-- <el-input v-model="form.token" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogUserFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitUidForm(uidform)"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div class="container_right">
        <div class="set_title_div">
          <div>api: {{ this.ApiId }}</div>
          <div class="alias_div">别名: {{ this.Alias }}</div>
        </div>
        <div class="set_div">
          <el-dialog
            title="币对添加"
            :visible.sync="dialogSymbolFormVisible"
            width="30%"
            @close="closeSymbolDialog"
            :close-on-click-modal="false"
          >
            <el-form
              size="medium"
              :model="symbolform"
              ref="symbolform"
              :rules="rules"
              label-width="20%"
              label-position="right"
            >
              <el-form-item label="token" prop="symbol1">
                <el-input
                  v-model="symbolform.symbol1"
                  autocomplete="off"
                  ref="symbol1"
                  @keyup.enter.native="nextFocus(0, 'symbolform')"
                ></el-input>
              </el-form-item>
              <el-form-item label="coin" prop="symbol2">
                <el-input
                  v-model="symbolform.symbol2"
                  autocomplete="off"
                  @keyup.enter.native="submitSymbolForm(symbolform)"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogSymbolFormVisible = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="submitSymbolForm(symbolform)"
                >确 定</el-button
              >
            </div>
          </el-dialog>
          <el-card class="box-card">
            <div slot="header" class="card_head">
              <span>币对</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="dialogSymbolFormVisible = true"
                >添加</el-button
              >
            </div>
            <div class="card_content">
              <el-table
                :data="symboltableData"
                style="width: 100%"
                :show-header="false"
                height="40vh"
                max-height="40vh"
              >
                <el-table-column prop="symbol" label="币对名"></el-table-column>
                <el-table-column fixed="right" label="操作" width="50px">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="
                        deletesymbolRow(scope.$index, symboltableData)
                      "
                      type="danger"
                      size="mini"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>用户权限</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="dialogUserFormVisible = true"
                >添加</el-button
              >
            </div>
            <div class="text item">
              <el-table
                :data="uidtableData"
                style="width: 100%"
                :show-header="false"
                height="40vh"
                max-height="40vh"
              >
                <el-table-column prop="uid" label="用户名"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="50px">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="
                        deleteuidRow(scope.$index, uidtableData)
                      "
                      type="danger"
                      size="mini"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./api";
import dbPermission from "@/proto/dbPermission_pb";
import dbUserInfo from "@/proto/dbUserInfo_pb";
import dbApiInfo from "@/proto/dbApiInfo_pb";

export default {
  data() {
    return {
      name: "Set",
      bLoading: false,
      input1: "",
      startDate: "",
      endDate: "",
      defaultExpandedKeys: [],
      apiList: [],
      userList: [],
      exchangeList: [],
      defaultexchange: {},
      editform: {},
      ApiId: "",
      Token: "",
      Alias: "",
      Exchange: "",
      DATA: "",
      NODE: "",
      msg: "Welcome to Settttttttttttttttttttttttttttt",
      tokenName: "",
      dialogTokenFormVisible: false,
      dialogApiFormVisible: false,
      dialogEditAliasVisible: false,
      dialogSymbolFormVisible: false,
      dialogUserFormVisible: false,
      tokenform: {
        token: ""
      },
      apiform: {
        apiId: "",
        alias: "",
        exchange: "",
        apiType: '1'
      },
      symbolform: {
        // token: "",
        // apiId: "",
        // alias: "",
        // exchange: "",
        symbol1: "",
        symbol2: ""
      },
      uidform: {
        // token: '',
        // apiId: '',
        // alias: '',
        // exchange: '',
        uid: ""
      },
      rules: {
        token: [
          { required: true, message: "请输入token名称", trigger: "change" },
          {
            required: true,
            pattern: /^[A-Z0-9]+$/,
            message: "token由大写英文字母和数字组成",
            trigger: "blur"
          }
        ],
        apiId: [{ required: true, message: "请输入apiid", trigger: "blur" }],
        alias: [
          { required: true, message: "请输入api别名", trigger: "change" }
        ],
        exchange: [
          { required: true, message: "请选择交易所", trigger: "change" }
        ],
        symbol1: [{ required: true, message: "请输入token", trigger: "blur" }],
        symbol2: [{ required: true, message: "请输入coin", trigger: "change" }],
        uid: [{ required: true, message: "请选择用户", trigger: "blur" }],
        apiType: [{ required: true, message: "请选择现货或合约", trigger: "blur" }]
      },
      formLabelWidth: "120px",
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeData: [],
      symboltableData: [],
      uidtableData: [
        {
          //   token: '',
          //   apiId: '',
          //   alias: '',
          //   exchange: '',
          // symbol: '',
          id: "",
          uid: ""
        }
      ],
    };
  },
  computed: {
    key() {
      return this.$route.path + new Date().getTime();
    }
  },
  methods: {
    // 获取api下拉框
    getApiList(Data) {
      this.apiList = [];
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      API.getApiList(data).then(res => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = dbApiInfo.DbApiList.deserializeBinary(buffer);
          var apiArray = [];
          var apiArrayY = [];
          message.getApisList().forEach(api => {
            var apiObj = {
              apiId: api.getApiid(),
              exchangeId: api.getExchangeid()
            };
            var apiId = apiObj.apiId;
            var token = Data.token;
            apiArray.push(apiObj);
            if (apiId.includes(token.toLowerCase())) {
              apiArrayY.push(apiObj);
              this.apiList = apiArrayY;
            }
          });
          if (apiArrayY.length === 0) {
            this.apiList = apiArray;
          }
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3001) {
            // 无效的登录凭证
            this.$router.push("/adminLogin");
          }
        }
      });
    },
    // 获取uid下拉框
    getUidList() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      API.getUserList(data).then(res => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = dbUserInfo.DbUserList.deserializeBinary(buffer);
          var userArray = [];
          message.getUsersList().forEach(uid => {
            var userobj = {
              uid: uid.getUid()
              // 'label': uid.getUid(),
            };
            userArray.push(userobj);
            this.userList = userArray;
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3001) {
            // 无效的登录凭证
            this.$router.push("/adminLogin");
          }
        }
      });
      return this.userList;
    },
    // 获取exchange下拉框
    getExchangesList() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      API.getExchangesList(data).then(res => {
        // console.log("--------------"+JSON.stringify(res.data))
        if (res.data) {
          this.exchangeList = res.data;
        } else {
          this.$message.error(res.data.errcode + "-" + res.data.errmsg);
          if (res.data.errcode === 3001) {
            // 无效的登录凭证
            this.$router.push("/adminLogin");
          }
        }
      });
    },
    // 获取节点相对应数据
    treeNodeClick(data, node, comp) {
      // console.log("Clickdata=", JSON.stringify(data));
      // console.log("Clicknode=", node);
      if (node.level === 1) {
        this.ApiId = "";
        this.Alias = "";
        this.Exchange = "";
        this.symboltableData = [];
        this.uidtableData = [];
      }
      if (node.isLeaf) {
        this.Token = data.token;
        this.ApiId = data.apiId;
        this.Alias = data.alias;
        this.Exchange = data.exchange;
        this.DATA = data;
        this.symboltableData = data.symbols;
        this.uidtableData = data.uids;
      }
    },
    // 修改别名
    submitAliasForm(editform) {
      var Data = this.DATA;
      this.$refs.editform.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            token: Data.token,
            apiId: Data.apiId,
            alias: editform.alias
          };
          API.ResetPermissionApiAlias(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.$message({
                  message: "修改成功！",
                  type: "success"
                });
                this.dialogEditAliasVisible = false;
                this.getTreeData();
                this.defaultTree();
              } else {
                this.dialogEditAliasVisible = false;
                this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "修改失败！" + error,
                type: "error"
              });
              this.dialogEditAliasVisible = false;
              // console.log(error.response.data.errcode)
            });
        } else {
          return false;
        }
      });
    },
    // 添加api下拉框
    ApiSelect(data) {
      this.apiform.apiId = data.apiId;
      // 给exchange赋值
      if (data.apiId) {
        this.exchangeList.forEach(exchange => {
          if (data.exchangeId === exchange.id) {
            this.defaultexchange = exchange;
            this.apiform.exchange = this.defaultexchange.name;
          }
        });
        // 给alias赋值，默认为apiId
        this.$set(this.apiform, "alias", data.apiId);
      }
    },
    // 添加api
    submitApiForm(apiform) {
      var Data = this.DATA;
      this.$refs.apiform.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            token: Data.token,
            apiId: apiform.apiId,
            alias: apiform.alias,
            exchange: this.defaultexchange.id,
            apiType:apiform.apiType,
          };
          API.AddPermissionApi(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.$message({
                  message: "添加成功！",
                  type: "success"
                });
                this.dialogApiFormVisible = false;
                this.getTreeData();
                this.defaultTree();
              } else {
                this.dialogApiFormVisible = false;
                this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "添加失败！" + error,
                type: "error"
              });
              this.dialogApiFormVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    // 添加token
    submitTokenForm(tokenform) {
      this.$refs.tokenform.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            token: tokenform.token
          };
          API.CreatePermissionToken(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.$message({
                  message: "添加成功！",
                  type: "success"
                });
                this.dialogTokenFormVisible = false;
                this.getTreeData();
                this.defaultTree();
              } else {
                this.dialogTokenFormVisible = false;
                this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "添加失败！" + error,
                type: "error"
              });
              this.dialogTokenFormVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    // 添加p-symbol
    submitSymbolForm(symbolform) {
      var Data = this.DATA;
      if (this.ApiId === "" || this.ApiId === undefined) {
        this.$message({
          message: "请选择api",
          type: "error"
        });
        this.dialogSymbolFormVisible = false;
      } else {
        var data = {};
        this.$refs.symbolform.validate(valid => {
          if (valid) {
            var symbols = [];
            let symbol = symbolform.symbol1 + "-" + symbolform.symbol2;
            symbols.push(symbol);
            data = {
              "admin-uid": localStorage.getItem("admin-uid"),
              token: this.Token,
              apiId: this.ApiId,
              Exchange: this.Exchange,
              symbols: symbols
            };
            API.AddPermissionApiSymbols(data)
              .then(res => {
                if (res.data.errcode === 0) {
                  this.$message({
                    message: "添加成功！",
                    type: "success"
                  });
                  console.log(res.data);
                  this.dialogSymbolFormVisible = false;
                  this.defaultTree();
                  var ress = res.data.symbols;
                  for (let item of ress) {
                    var obj = {
                      symbol: item
                    };
                    Data.symbols.push(obj);
                  }
                  this.symboltableData = Data.symbols;
                } else {
                  this.dialogSymbolFormVisible = false;
                  this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                  if (res.data.errcode === 3001) {
                    // 无效的登录凭证
                    this.$router.push("/adminLogin");
                  }
                }
              })
              .catch(error => {
                this.$message({
                  message: "添加失败！" + error,
                  type: "error"
                });
                this.dialogSymbolFormVisible = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    // 添加p-uid
    submitUidForm(uidform) {
      var Data = this.DATA;
      if (this.ApiId === "" || this.ApiId === undefined) {
        this.$message({
          message: "请选择api",
          type: "error"
        });
        this.dialogUserFormVisible = false;
      } else {
        var data = {};
        this.$refs.uidform.validate(valid => {
          if (valid) {
            // var uids = [];
            // uids.push(uidform.uid);
            data = {
              "admin-uid": localStorage.getItem("admin-uid"),
              token: this.Token,
              apiId: this.ApiId,
              uids: uidform.uid
            };
            API.AddPermissionApiUids(data)
              .then(res => {
                if (res.data.errcode === 0) {
                  this.$message({
                    message: "添加成功！",
                    type: "success"
                  });
                  this.dialogUserFormVisible = false;
                  this.defaultTree();
                  for (let item of data.uids) {
                    var obj = {
                      uid: item
                    };
                    Data.uids.push(obj);
                  }
                  this.uidtableData = Data.uids;
                } else {
                  this.dialogUserFormVisible = false;
                  this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                  if (res.data.errcode === 3001) {
                    // 无效的登录凭证
                    this.$router.push("/adminLogin");
                  }
                }
              })
              .catch(error => {
                this.$message({
                  message: "添加失败！" + error,
                  type: "error"
                });
                this.dialogUserFormVisible = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    // 移除symbol的权限
    deletesymbolRow(index, symboltableData) {
      this.$confirm("确认移除币对?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {};
          var symbols = [];
          symbols.push(symboltableData[index].symbol);
          data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            token: this.Token,
            apiId: this.ApiId,
            Exchange: this.Exchange,
            symbols: symbols
          };
          API.DeletePermissionApiSymbols(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.$message({
                  message: "移除成功！",
                  type: "success"
                });
                this.defaultTree();
                for (let i = 0; i < this.symboltableData.length; i += 1) {
                  for (let item of data.symbols) {
                    var obj = {
                      symbol: item
                    };
                  }
                  if (this.symboltableData[i].symbol === obj.symbol) {
                    this.symboltableData.splice(
                      this.symboltableData.indexOf(this.symboltableData[i]),
                      1
                    );
                    i -= 1;
                  }
                }
              } else {
                this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "移除失败！" + error,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除"
          });
        });
    },
    // 移除uid的权限
    deleteuidRow(index, uidtableData) {
      this.$confirm("确认移除用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {};
          var uids = [];
          uids.push(uidtableData[index].uid);
          data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            token: this.Token,
            apiId: this.ApiId,
            uids: uids
          };
          API.DeletePermissionApiUids(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.$message({
                  message: "移除成功！",
                  type: "success"
                });
                this.defaultTree();
                for (let item of data.uids) {
                  var obj = {
                    uid: item
                  };
                }
                for (let i = 0; i < this.uidtableData.length; i++) {
                  if (this.uidtableData[i].uid === obj.uid) {
                    this.uidtableData.splice(
                      this.uidtableData.indexOf(this.uidtableData[i]),
                      1
                    );
                    i--;
                  }
                }
              } else {
                this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "移除失败！" + error,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除"
          });
        });
    },
    // 默认展开及数据
    defaultTree() {
      var Data = this.DATA;
      if (Data.id !== undefined) {
        // 设置增删改后的默认展开节点
        this.defaultExpandedKeys.splice(0, 1, Data.id);
        // 设置选中节点高亮
        setTimeout(() => {
          this.$refs.menutree.setCurrentKey(this.defaultExpandedKeys[0]);
        }, 300);
      } else {
        // 设置默认展开节点及默认显示symbols和uids
        var apiArray = this.treeData[0].children;
        if (apiArray.length == 0) {
          return 
        }
        this.defaultExpandedKeys.push(apiArray[0].id);
        // console.log(this.defaultExpandedKeys[0])
        // 设置默认选中节点高亮
        this.$nextTick(function() {
          this.$refs.menutree.setCurrentKey(this.defaultExpandedKeys[0]);
        });
        this.symboltableData = apiArray[0].symbols;
        this.uidtableData = apiArray[0].uids;
        this.ApiId = apiArray[0].apiId;
        this.Alias = apiArray[0].alias;
        this.Token = apiArray[0].token;
        this.DATA = apiArray[0];
      }
    },
    // 初始化
    async init() {
      // 整页Loading
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      await this.getTreeData();
      loading.close();
      await this.defaultTree();
      this.getUidList();
      this.getExchangesList();
    },
    // 初始化树数据
    async getTreeData() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      await API.getPermissionList(data)
        .then(res => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message = dbPermission.DbPermissionList.deserializeBinary(
              buffer
            );
            var treeArray = [];
            message.getPermissionsList().forEach(element => {
              var token = element.getToken();
              var item = {
                id: token,
                label: token,
                token: token,
                type: "token"
              };
              var apiArray = [];
              element.getApisList().forEach(api => {
                var apiObj = {
                  id: token + api.getId(),
                  token: element.getToken(),
                  apiId: api.getId(),
                  label: api.getAlias(),
                  alias: api.getAlias(),
                  exchange: api.getExchange(),
                  ban: api.getBan(),
                  type: "api"
                };
                var symbolArray = [];
                api.getSymbolsList().forEach(symbol => {
                  var symbolObj = {
                    id: token + "-" + api.getAlias() + "-" + symbol,
                    token: token,
                    label: symbol,
                    symbol: symbol
                  };
                  symbolArray.push(symbolObj);
                });
                var uidArray = [];
                api.getUidsList().forEach(uid => {
                  var uidObj = {
                    id: uid,
                    uid: uid
                  };
                  uidArray.push(uidObj);
                });
                apiObj.symbols = symbolArray;
                apiObj.uids = uidArray;
                apiArray.push(apiObj);
              });
              item.children = apiArray;
              treeArray.push(item);
            });
            this.treeData = treeArray;
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3001) {
              // 无效的登录凭证
              this.$router.push("/adminLogin");
            }
          }
        })
        .catch(err => {
          console.log("err=", err);
        });
    },
    // 追加api
    append(node, data) {
      this.DATA = data;
      this.NODE = node;
      this.getApiList(data);
      this.dialogApiFormVisible = true;
    },
    // 修改别名
    edit(node, data) {
      this.DATA = data;
      this.NODE = node;
      if (data.type === "api") {
        this.dialogEditAliasVisible = true;
      }
      // console.log("edit node=", node);
      // console.log("edit data=", data);
    },
    // 禁用api
    ban(node, data) {
      if (data.type === "api") {
        this.$confirm("确认禁用api?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            var apidata = {
              "admin-uid": localStorage.getItem("admin-uid"),
              token: data.token,
              apiId: data.apiId
            };
            API.BanPermissionApi(apidata)
              .then(res => {
                if (res.data.errcode === 0) {
                  this.$message({
                    message: "禁用成功！",
                    type: "success"
                  });
                  this.getTreeData();
                  this.defaultTree();
                } else {
                  this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                  if (res.data.errcode === 3001) {
                    // 无效的登录凭证
                    this.$router.push("/adminLogin");
                  }
                }
              })
              .catch(error => {
                this.$message({
                  message: "禁用失败！" + error,
                  type: "error"
                });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消禁用"
            });
          });
      }
    },
    // 恢复api
    resume(node, data) {
      if (data.type === "api") {
        this.$confirm("确认恢复api?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            var apidata = {
              "admin-uid": localStorage.getItem("admin-uid"),
              token: data.token,
              apiId: data.apiId
            };
            API.ResumePermissionApi(apidata)
              .then(res => {
                if (res.data.errcode === 0) {
                  this.$message({
                    message: "恢复成功！",
                    type: "success"
                  });
                  this.getTreeData();
                  this.defaultTree();
                } else {
                  this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                  if (res.data.errcode === 3001) {
                    // 无效的登录凭证
                    this.$router.push("/adminLogin");
                  }
                }
              })
              .catch(error => {
                this.$message({
                  message: "恢复失败！" + error,
                  type: "error"
                });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消恢复"
            });
          });
      }
    },
    // 删除api
    remove(node, data) {
      if (data.type === "api") {
        this.$confirm("确认删除api?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            var apidata = {
              "admin-uid": localStorage.getItem("admin-uid"),
              token: data.token,
              apiId: data.apiId
            };
            API.DeletePermissionApi(apidata)
              .then(res => {
                if (res.data.errcode === 0) {
                  this.$message({
                    message: "删除成功！",
                    type: "success"
                  });
                  this.getTreeData();
                  this.defaultTree();
                  this.symboltableData = [];
                  this.uidtableData = [];
                  this.ApiId = "";
                  this.Alias = "";
                } else {
                  this.$message.error(res.data.errcode + ":" + res.data.errmsg);
                  if (res.data.errcode === 3001) {
                    // 无效的登录凭证
                    this.$router.push("/adminLogin");
                  }
                }
              })
              .catch(error => {
                this.$message({
                  message: "删除失败！" + error,
                  type: "error"
                });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    nextFocus(index, form) {
      // 按回车键，聚焦下一个input。
      this.$refs[form].$el[index + 1].focus();
    },
    // 关闭弹框的事件
    closeTokenDialog() {
      this.$refs.tokenform.resetFields();
      this.tokenform = {};
    },
    closeApiDialog() {
      this.$refs.apiform.resetFields();
      this.apiform = {};
    },
    closeEditDialog() {
      this.$refs.editform.resetFields();
      this.editform = {}; // 清空数据
    },
    closeSymbolDialog() {
      this.$refs.symbolform.resetFields();
      this.symbolform = {};
      // this.$refs.symbolform.clearValidate();
    },
    closeUidDialog() {
      this.$refs.uidform.resetFields();
      this.uidform = {};
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped>
@import "../assets/css/set.scss";
@import "../assets/css/index.scss";
</style>
